<template>
  <div class="flex-grow-1 main-container-fluid ideas-wrapper" ref="listContainer">
    <div class="col-12 col-md-10 col-lg-10 h-100">
      <div>
        <div class="d-flex justify-content-center" v-if="ideaLists && ideaLists.length === 0">
          <info-box class="no-result">
            <template slot="message">
              You don’t have any Idea lists in the current timeline. When you do, this is where
              you’ll see them
            </template>
            <a
              @click="showAddIdeaListModal = true"
              class="text-decoration-none border-gradient rounded-pill px-4 py-1 pointer"
            >
              <span class="px-3 text-gradient">Add a new Idea list</span>
            </a>
          </info-box>
        </div>
        <div class="idea-list-wrapper" v-else-if="ideaLists">
          <idea-list-row
            v-for="ideaList in ideaLists"
            :list-id="ideaList.id"
            :key="ideaList.id"
            @deleted="onIdeaListDelete(ideaList.id)"
            @updated="onIdeaListUpdate"
          />
          <b-button
            variant="link"
            class="text-secondary text-medium create-idea-list"
            @click="showAddIdeaListModal = true"
            >New Idea list
          </b-button>
        </div>
        <idea-list-creator
          :idea-list="ideaListToEdit"
          :org-id="orgId"
          :team-id="teamId"
          @created="onIdeaListCreate"
          v-model="showAddIdeaListModal"
          v-if="showAddIdeaListModal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { trackEvent } from '@/analytics'
import { EVENT_ACTION, EVENT_CATEGORY, EVENT_NAME } from '@/constants/analytics'
import { ENTITY_TYPE } from '@/constants/entities'
import selectFirstItem from '@/utils/selectFirstItem'
import { mapActions } from 'vuex'
import * as R from 'ramda'
import * as keymapService from '@/services/keymapService/keymapService'
import IdeasKeyboardNavMixins from '@/mixins/IdeasKeyboardNavMixins'
import { BButton } from 'bootstrap-vue'
import IdeaListCreator from '@/components/ideas/IdeaListCreator'
import IdeaListRow from '@/components/ideas/IdeaListRow'
import InfoBox from '@/components/InfoBox'

/**
 * This renders the List of IdeaList of team/org
 *
 */
export default {
  name: 'IdeaLists',
  props: ['orgId', 'teamId'],
  components: {
    IdeaListRow,
    InfoBox,
    IdeaListCreator,
    BButton
  },
  mixins: [IdeasKeyboardNavMixins],
  data() {
    return {
      ideaLists: null,
      showAddIdeaListModal: false,
      ideaListToEdit: null
    }
  },
  methods: {
    ...mapActions('idea', ['getIdeaLists']),
    async refreshIdeaLists() {
      this.ideaLists = await this.getIdeaLists({
        orgId: this.orgId,
        teamId: this.teamId
      })
    },
    onIdeaListCreate() {
      this.refreshIdeaLists()
    },
    onIdeaListDelete(id) {
      this.ideaLists = this.ideaLists.filter(ideaList => ideaList.id !== id)
    },
    onIdeaListUpdate(ideaList) {
      const index = R.findIndex(R.propEq('id', ideaList.id), this.ideaLists)
      this.ideaLists = R.update(index, ideaList, this.ideaLists)
    },
    addIdea() {
      const selectedItem = keymapService.selectedListItem(this.$el)
      if (selectedItem) {
        const selectedIdeaList = this.getIdeaListRowVue(selectedItem)
        selectedIdeaList && selectedIdeaList.addIdea()
      }
    },
    initializeKeyMapService() {
      keymapService.activateCategory('ideaLists', {
        'previous-item': this.selectPreviousItem,
        'next-item': this.selectNextItem,
        'toggle-expansion': () => this.toggleItem(),
        open: e => this.viewItem(e, ENTITY_TYPE.IDEA_LIST),
        'expand-item': this.expandItem,
        'collapse-item': this.collapseItem,
        'edit-idea': this.editIdea,
        'done-undone-item': this.doneUndone,
        'add-idea': this.addIdea,
        'cancel-editing': this.cancelIdeaEditing,
        comment: this.comment
      })
    }
  },
  beforeDestroy() {
    keymapService.deactivateCategory('ideaLists')
  },
  async mounted() {
    await this.refreshIdeaLists()
    this.initializeKeyMapService()
    this.$nextTick(() => {
      selectFirstItem(this.$refs.listContainer)
    })
    trackEvent(EVENT_CATEGORY.NAVIGATION, EVENT_ACTION.OPEN_PAGE, EVENT_NAME.IDEA_LISTS)
  }
}
</script>

<style lang="scss" scoped>
.main-container-fluid {
  margin: 0 auto;
  width: 100%;
}

.ideas-wrapper {
  display: flex;
  justify-content: center;
  width: inherit;
  flex-shrink: 0;
}

.create-idea-list {
  margin-left: 38px;
  margin-top: 12px;
}

.idea-list-wrapper {
  padding-left: 14px;
}

.no-result {
  height: 400px;
}
</style>
